import { defineStore } from "pinia"
import { AppliedFilters } from "../entitites/applied-filters.interface";
import { Store } from "@/common/stores.enum";
import { useSearchResultsStore } from "./SearchResults.store";

export const useAppliedFiltersStore = defineStore(Store.AppliedFilters, {

    state: (): AppliedFilters => ({}),

    actions: {
        async addAppliedFilters(params: AppliedFilters): Promise<void> {
            this.$patch((state) =>{
                if (params.searchText !== undefined) {
                    state.searchText = params.searchText;
                }
                if (params.country !== undefined) {
                    state.country = typeof params.country === 'string'
                        ? (<string>params.country).split(",")
                        : params.country;
                }
                if (params.city !== undefined) {
                    state.city = typeof params.city === 'string'
                        ? (<string>params.city).split(",")
                        : params.city;
                }
                if (params.category !== undefined) {
                    state.category = typeof params.category === 'string'
                        ? (<string>params.category).split(",").map(Number)
                        : params.category;
                }
                if (params.mainCategory !== undefined) {
                    state.mainCategory = typeof params.mainCategory === 'string'
                        ? (<string>params.mainCategory).split(",").map(Number)
                        : params.mainCategory;
                }
                if (params.dateStart !== undefined) {
                    state.dateStart = typeof params.dateStart !== 'string' && params.dateStart !== null
                        ? new Date(params.dateStart)
                        : params.dateStart;
                }
                if (params.dateEnd !== undefined) {
                    state.dateEnd = typeof params.dateEnd !== 'string' && params.dateEnd !== null
                        ? new Date(params.dateEnd)
                        : params.dateEnd;
                }
                if (params.lang !== undefined) {
                    state.lang = params.lang;
                }
            })            
        },

        async removeAppliedFiltersFromState(params: AppliedFilters): Promise<void> {
            this.$patch((state) =>{
                Object.entries(params).forEach((p) => {
                    const categoryName = p[0];
                    const filterValue = p[1];

                    if (categoryName === 'searchText') {
                        state.searchText = undefined;

                        return;
                    }

                    if (categoryName === 'dateStart') {
                        state.dateStart = undefined;

                        return;
                    }

                    if (categoryName === 'dateEnd') {
                        state.dateEnd = undefined;

                        return;
                    }

                    const filter = state[categoryName];

                    if (filter) {
                        filter.splice(filter.indexOf(filterValue), 1);
                    }
                });
            })

            const searchResults = useSearchResultsStore();
            searchResults.formatParams(this.$state);
        },

        async updateAppliedFilters(params: AppliedFilters): Promise<void> {
            const searchResults = useSearchResultsStore();
            await this.addAppliedFilters(params);
            searchResults.formatParams(this.$state);
        },
        
        async deleteAppliedFilters(params: AppliedFilters): Promise<void> {
            const searchResults = useSearchResultsStore();
            await this.removeAppliedFiltersFromState(params);
            searchResults.formatParams(this.$state);
        }
    }

})
